export default [
  {
    filter: (value) => true,
    visible: false,
    align: "start",
    value: "ID",
    text: "ID",
    class: "px-1 text-left",
    width: "2rem",
    position: 101,
  },
  {
    filter: (value) => true,
    visible: true,
    align: "start",
    value: "Pogodba_ID",
    text: "Pogodba ID",
    class: "px-1 text-left",
    width: "7rem",
    position: 102,
  },
  {
    // filter: (value) => true,
    visible: true,
    align: "start",
    value: "Stranka",
    text: "Stranka",
    class: "px-1 text-truncate",
    width: "10rem",
    position: 103,
  },
  {
    filter: (value) => true,
    visible: true,
    align: "start",
    value: "Produkt_Naziv",
    text: "Produkt",
    class: "px-1 text-left",
    width: "5rem",
    position: 104,
  },
  {
    filter: (value) => true,
    visible: true,
    align: "start",
    value: "Vozilo",
    text: "Vozilo",
    class: "px-1 text-truncate",
    width: "10rem",
    position: 105,
  },
  {
    filter: (value) => true,
    visible: true,
    align: "start",
    value: "Datum_SQL",
    text: "Datum",
    class: "px-1 text-left",
    width: "6rem",
    position: 106,
    formatter: "date",
  },
  {
    filter: (value) => true,
    visible: true,
    align: "start",
    value: "Opis_skode",
    text: "Opis škode",
    class: "px-1 text-truncate",
    width: "12rem",
    position: 107,
  },
  {
    filter: (value) => true,
    visible: true,
    align: "start",
    value: "Delavnica",
    text: "Delavnica",
    class: "px-1 text-truncate",
    width: "10rem",
    position: 108,
  },
  {
    filter: (value) => true,
    visible: true,
    align: "start",
    value: "Agent_ID",
    text: "Agent ID",
    class: "px-1 text-truncate",
    width: "6rem",
    position: 109,
  },
  {
    filter: (value) => true,
    visible: true,
    align: "end",
    value: "Aktualni_km",
    text: "km",
    class: "px-1 text-right",
    width: "6rem",
    position: 110,
    formatter: "currency",
  },
  {
    filter: (value) => true,
    visible: true,
    align: "end",
    value: "Znesek_izplacilo",
    text: "Izplačilo",
    class: "px-1 pr-2 text-right",
    width: "6rem",
    position: 111,
    formatter: "currency",
  },
  {
    filter: (value) => true,
    visible: true,
    align: "end",
    value: "Skupaj_s_popustom",
    text: "S popustom",
    class: "px-1 pr-2 text-right",
    width: "6rem",
    position: 112,
    formatter: "currency",
  },
  {
    filter: (value) => true,
    visible: true,
    align: "end",
    value: "Znesek_soudelezba",
    text: "Soudeležba",
    class: "px-1 pr-2 text-right",
    width: "6rem",
    position: 211,
    formatter: "currency",
  },
  {
    filter: (value) => true,
    visible: false,
    align: "start",
    value: "Status",
    text: "ST",
    class: "px-1 text-center",
    width: "3rem",
    position: 112,
  },
  {
    filter: (value) => true,
    visible: false,
    align: "start",
    value: "ZS",
    text: "ZŠ",
    class: "px-1 text-left",
    width: "5rem",
    position: 113,
  },
  {
    filter: (value) => true,
    visible: true,
    align: "start",
    value: "Opomba",
    text: "Opomba",
    class: "px-1 text-truncate",
    width: "15rem",
    position: 114,
  },
  {
    filter: (value) => true,
    visible: false,
    align: "end",
    value: "Znesek_zahtevek",
    text: "Zahtevek €",
    class: "px-1 text-right",
    width: "6rem",
    position: 115,
    formatter: "currency",
  },
  {
    filter: (value) => true,
    visible: false,
    align: "start",
    value: "Opis_zavrnitev",
    text: "Opis zavrnitev",
    class: "px-1 text-truncate",
    width: "20rem",
    position: 116,
  },
  {
    filter: (value) => true,
    visible: true,
    align: "end",
    value: "Leto",
    text: "Leto",
    class: "px-1 text-right",
    width: "3rem",
    position: 117,
  },
  {
    filter: (value) => true,
    visible: false,
    align: "end",
    value: "Search_string",
    text: "Poln tekst",
    class: "px-1 text-right",
    width: "3rem",
    position: 901,
  },
];
